import { v4 as uuidv4 } from "uuid";
export class PAWorkFlowGridViewModel {
    constructor() {
        this.id = uuidv4();
        this.name = "";
        this.isArchived = "";
        this.workFlowUsuageCount = 0;
    }
}
export default class PAWorkFlowGridView extends PAWorkFlowGridViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
